































import { defineComponent, computed } from '@vue/composition-api';
import { PropType, PropOptions } from 'vue';

const tabTypes = ['joined', 'explore'];
type Options  = 'joined' | 'explore';

export default defineComponent({
    props: {
        value: {
            type: String,
        },
    },
    setup(props, context) {
        const gliderTranslate = computed(() => {
            const indexOfSelectedTab = tabTypes.indexOf(props.value);
            const percentageTransform = indexOfSelectedTab * 100;
            return `translateX(${percentageTransform}%)`;
        });
        return {
            gliderTranslate,
            tabTypes,
        };
    },
});
